import type { Logger } from 'logger'
import { createNoopLogger } from 'logger'
import React, { createContext, useContext } from 'react'

// Create a silent (no-op) logger instance to avoid leaking logs in the browser
const defaultLogger = createNoopLogger()

// Create the context with the default logger
export const LoggerContext = createContext<Logger>(defaultLogger)

// Provider component for the logger
export const LoggerProvider: React.FC<{ children: React.ReactNode; logger?: Logger }> = ({
  children,
  logger = defaultLogger,
}) => <LoggerContext.Provider value={logger}>{children}</LoggerContext.Provider>

// Custom hook to use the logger
export const useLogger = (): Logger => useContext(LoggerContext)

// Export the default logger for use outside of React components
export const appLogger = defaultLogger
